/**
 * Условный логгер для production/development режимов
 * В production режиме логи отключены
 */
const isDev = process.env.NODE_ENV === 'development';
const noop = () => { };
const logger = {
    log: isDev ? console.log.bind(console) : noop,
    warn: isDev ? console.warn.bind(console) : noop,
    error: console.error.bind(console), // Ошибки логируем всегда
    info: isDev ? console.info.bind(console) : noop,
    debug: isDev ? console.debug.bind(console) : noop,
};
export default logger;
